import { ArrowPathIcon } from '@heroicons/react/20/solid';
import { Dialog, DialogTitle, DialogDescription, DialogActions } from './dialog';
import { Button } from './button';
import { useVersionCheck } from '../hooks/useVersionCheck';

const ACCENT = '#1b4d2e';

export default function UpdateDialog() {
  const { updateAvailable, dismiss, reload } = useVersionCheck();

  return (
    <Dialog open={updateAvailable} onClose={dismiss} size="sm">
      <div className="flex items-center gap-3">
        <div
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg"
          style={{ backgroundColor: ACCENT + '1a' }}
        >
          <ArrowPathIcon className="h-4 w-4" style={{ color: ACCENT }} />
        </div>
        <DialogTitle>Nueva versión disponible</DialogTitle>
      </div>
      <DialogDescription>
        Hay una nueva versión de Venueboard disponible. Recarga la página para obtener las últimas mejoras y correcciones.
      </DialogDescription>
      <DialogActions>
        <Button plain onClick={dismiss}>
          Más tarde
        </Button>
        <button
          onClick={reload}
          className="inline-flex items-center justify-center gap-2 rounded-lg px-3 py-1.5 text-sm font-semibold text-white shadow-sm transition hover:opacity-90"
          style={{ backgroundColor: ACCENT }}
        >
          Recargar ahora
        </button>
      </DialogActions>
    </Dialog>
  );
}
